import {styled} from '@mui/material/styles';
import {useTheme, Toolbar, IconButton, Menu, MenuItem, Box, Typography, Button, Avatar, Stack, Grid, Paper} from "@mui/material";
import { useSnackbar } from "notistack";

import MuiAppBar from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import CustomTypography from "../ui/CustomTypography";
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useEffect, useState } from 'react';
import CustomModal from '../ui/custom-modal.component';
import UserProfileDialog from '../../../plugins/ProfilePlugin/components/user/user-profile.dialog';
import useUserProfile from '../../../plugins/ProfilePlugin/hooks/useUserProfile';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { useRBACStore, useRBAC } from '../../../plugins/RBACPlugin';
import CustomDialog from '../common/custom-dialog.component';
import CloseIcon from '@mui/icons-material/Close';

const drawerWidth = 240;

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string?.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      height: 80,
      width: 80,
      border: '2px solid #fff',
    },
    children: `${name?.split(' ')[0][0]}`,
  };
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
    })(({ theme }) => ({
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
        }),
        variants: [
        {
            props: ({ open }) => open,
            style: {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            },
        },
    ],
}));

const Appbar = (props) => {
    const {open, handleDrawerOpen } = props;

    const {viewProfile, profileDetailsV2, loading, profileTypeList, getProfile} = useUserProfile();

    const [anchorEl, setAnchorEl] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [selectedProfile, setSelectedProfile] = useState("");

    const {instance} = useMsal();
    const handleCloseModal = () => setOpenModal(false);

    const { enqueueSnackbar } = useSnackbar();

    const {setCurrentProfile, currentProfile} = useRBACStore();
    const {getProfilePermissions, isDoneGetProfilePermissions, profilePermissions, errorGetProfilePermissions} = useRBAC()

    const theme = useTheme();

    const navigate = useNavigate()

    useEffect(() => {
        getProfile();
    }, [])

    useEffect(() => {
        if (selectedProfile && isDoneGetProfilePermissions && profilePermissions.length > 0) {
            setCurrentProfile({
                profileId: selectedProfile.profile_uid,
                profileType: selectedProfile.profile_type,
                permissions: profilePermissions,
                orgId: selectedProfile.org_uid,
                role: selectedProfile.role,
            }).then(() => {
                window.location.reload();
            })
        }
    }, [JSON.stringify(selectedProfile), JSON.stringify(profilePermissions), isDoneGetProfilePermissions])

    useEffect(() => {
        if (errorGetProfilePermissions) {
            let err_msg = errorGetProfilePermissions?.error || errorGetProfilePermissions?.message || "Something went wrong."
            enqueueSnackbar(err_msg, {
                variant: "error",
                autoHideDuration: 3000
            });
        }
    }, [JSON.stringify(errorGetProfilePermissions)])

    const handleLogout = async () => {
        try {
          await instance.logoutPopup();
          localStorage.clear();
          navigate("/");
         
    
        } catch (error) {
          console.log("logout error xxxx", error);
        }
      }

    const handleChangeProfile = () => {
        setOpenModal(true)
    }

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleSelectProfile = (profile) => {
        console.log("profile bbbbb", profile);
        setSelectedProfile(profile)
        localStorage.setItem("profile_uid", profile.profile_uid);
        // get new profile permissions
        getProfilePermissions(profile.profile_uid);
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        viewProfile()
    },[])

    const handleViewProfile = () => {
        handleCloseModal()
        navigate('/profile')
    }

    const handleViewAccount = () => {
        handleClose()
        navigate('/account')
    }


    console.log('get currentProfile:', currentProfile);
    return (
        <AppBar position="fixed" open={open} sx={{bgcolor: theme.palette.background.main}}>
            <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    sx={[
                        {marginRight: 5, color: "#605c5c"},
                        open && {display: 'none'},
                    ]}
                >
                    <MenuIcon />
                </IconButton>

                {!open && 
                    <CustomTypography 
                        variant="h5"
                        text={"SBMA"}
                        customStyles={{
                            marginBottom: 0, 
                            fontWeight: 600, 
                            fontSize: 18,
                        }}
                    />
                }
                <Box sx={{flexGrow: 1}}/>
                <Button sx={{textTransform:'none', fontSize: 14, mr: 2}} onClick={handleChangeProfile}>{currentProfile?.role}</Button>
                <div>
                    
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="info"
                    >
                        <AccountCircle />
                    </IconButton>
                    <Menu sx={{top: "35px"}}
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        keepMounted
                        transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleViewAccount}>My Profile</MenuItem>
                        {/* <MenuItem onClick={handleClose}>Settings</MenuItem>
                        <MenuItem onClick={handleClose}>Preferences</MenuItem>
                        <MenuItem onClick={handleClose}>Activity Logs</MenuItem>
                        <MenuItem onClick={handleClose}>Signin Logs</MenuItem> */}
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                    </Menu>
              </div>
            </Toolbar>
            <CustomDialog
                open={openModal}
                handleClose={handleCloseModal}
                content={
                <Grid container spacing={2} sx={{height:"100%"}}>
                    <Grid item size={{xs:12, sm: 6}}  sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '100%', // ensures vertical centering
                        bgcolor:'#0b99da'
                    }}>
                        <Stack
                            direction="column"
                            spacing={2}
                            alignItems="center"
                            justifyContent="center"
                        >
                        <Avatar sx={{border: "3px solid #fff !important"}} {...stringAvatar(profileDetailsV2?.role)} />
                        <Stack direction="column" alignItems="center" sx={{m: '8px !important'}}>
                            <Typography variant="h6" sx={{color:'#fff'}}>{profileDetailsV2?.role}</Typography>
                            <Typography sx={{color:'#fff'}}>{profileDetailsV2?.profile_type}</Typography>
                            <Button variant="outlined" sx={{ mt: 1, bgcolor:'white' }} onClick={handleViewProfile}>
                                View Profile
                            </Button>
                        </Stack>
                        </Stack>
                    </Grid>

                    <Grid size={{xs:12, sm: 6}} sx={{pt: 2}}>
                        <Stack spacing={2}>
                            <Box sx={{display: 'flex', alignItems:'center'}}>
                                <Typography sx={{fontSize: 18, fontWeight: "bold", display:"fixed"}}>Select Profile</Typography>
                                <Box sx={{flexGrow: 1}}/>
                                <IconButton onClick={handleCloseModal} sx={{mr: 1}}><CloseIcon/></IconButton>
                            </Box>
                            <UserProfileDialog handleSelectProfile={handleSelectProfile} loading={loading} profileTypeList={profileTypeList}  />
                        </Stack>
                    </Grid>
                </Grid>
                }
            />
        </AppBar>
    )
}

export default Appbar